<template>
    <div>
        <star-rating :rating="rating" :show-rating="false" :star-size="20"
        :read-only="true" :max-rating="maxRating"></star-rating>
    </div>
</template>
<script>
import BaseConfiguration from "../../../../config/base.js";
    import {
        COMPONENT_NAME,
        PATHNAME,DATE_TIME_FORMAT,
        FLIGHT_SELECTION_STATUS
    } from "../../../../util/constants";
    
import StarRating from 'vue-star-rating'
// Vue.component('star-rating', StarRating);
export default {
    name: 'cStarRating',
        components:{
            StarRating
            // cConnectingFlightInfo
        },
        props: {
            rating: {
                type: Number
            },
             maxRating: {
                type: Number,
                default:5
            },
            
           
        },
        data: () => ({

        }),
    
}
</script>